const REFERRED_BY_KEY = 'referredBy';

/**
 * Sets 'referredBy' to the current route's path.
 * @param {{path: string}} route The current route.
 */
function saveReferredBy(route) {
  if (route.path == null) {
    throw new Error('route.path must be defined');
  }
  localStorage.setItem(REFERRED_BY_KEY, route.path);
}

/**
 * Retrieves and clears 'referredBy' from localStorage
 * @return {string} the value of 'referredBy'; '/' if not present
 */
function getAndClearReferredBy() {
  const referredBy = localStorage.getItem(REFERRED_BY_KEY) || '/';
  localStorage.removeItem(REFERRED_BY_KEY);
  return referredBy;
}

export default {saveReferredBy, getAndClearReferredBy};
